"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBoundary = void 0;
var _logger = require("@ori/logger");
var _ProductBoxSkeleton = require("./ProductBoxSkeleton");
var _jsxRuntime = require("react/jsx-runtime");
const ErrorBoundary = ({
  children,
  logger
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
  fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductBoxSkeleton.ProductBoxSkeleton, {
    animation: "pulse"
  }),
  logger: logger,
  children: children
});
exports.ErrorBoundary = ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map